import { SignerAppSignatureRequestGetResponse } from '@dropbox/sign-internal-client';
import samplePage from 'signer-app/signer-experience/sample-page.png';
import tallPage from 'signer-app/signer-experience/tall-page.jpg';

type SignatureRequest =
  SignerAppSignatureRequestGetResponse['signatureRequest'];
type Field = SignatureRequest['fields'][0];

const DPI = 80;
export const zenPage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQIW2MQOfH6PwAFggLH3a2quwAAAABJRU5ErkJggg==';
export const cyanPage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjEDnx+j8ABYICx2ygQeAAAAAASUVORK5CYII=';
export const greenPage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjEA9z/A8AAuQBronxTZwAAAAASUVORK5CYII=';

export const drWhoSignature =
  'data:image/png;base64,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';

const signature1: Field = {
  id: 'signature-1',
  pageIndex: 0,
  name: 'Signature1',
  x: 182,
  y: 169,
  required: true,
  linkId: null,
  integrationMetadata: null,
  type: 'signature',
  width: 108,
  height: 27,
  signer: '1',
  documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
};

const checkbox1: Field = {
  id: 'checkbox-1',
  pageIndex: 0,
  x: 485,
  y: 616,
  required: true,
  linkId: null,
  type: 'checkbox',
  width: 18,
  height: 18,
  signer: '1',
  checked: false,
  documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
  name: 'Checkbox1',
  integrationMetadata: null,
};

export const originalFields: Field[] = [
  signature1,
  {
    id: 'initial-1',
    pageIndex: 0,
    name: 'Initial1',
    x: 194,
    y: 259,
    required: true,
    linkId: null,
    integrationMetadata: null,
    type: 'initials',
    width: 72,
    height: 27,
    signer: '1',
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
  },
  {
    id: 'textbox-1',
    fontSize: 12,
    pageIndex: 0,
    name: 'Animal',
    x: 181,
    y: 367,
    required: true,
    linkId: null,
    integrationMetadata: null,
    type: 'text',
    width: 72,
    height: 12,
    lineHeight: 12,
    masked: false,
    signer: '1',
    fontFamily: 'arial',
    placeholder: '',
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
  },
  {
    id: 'textbox-2',
    fontSize: 12,
    pageIndex: 0,
    x: 180,
    y: 462,
    required: true,
    linkId: null,
    validationType: 'numbers_only',
    type: 'text',
    width: 72,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'arial',
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    placeholder: 'Favorite number',
    integrationMetadata: null,
    masked: true,
    name: 'Favorite Number (masked)',
  },
  {
    id: 'textbox-3',
    validationType: 'email_address',
    fontSize: 12,
    pageIndex: 0,
    x: 176,
    y: 554,
    required: true,
    linkId: null,
    type: 'text',
    width: 150,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'arial',
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    placeholder: '',
    integrationMetadata: null,
    name: 'Textbox3',
  },
  {
    id: 'date-1',
    fontSize: 12,
    pageIndex: 0,
    x: 488,
    y: 175,
    required: true,
    linkId: null,
    type: 'date',
    width: 104,
    height: 18,
    dateFormat: 'MM / DD / YYYY',
    signer: '1',
    fontFamily: 'arial',
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    name: 'DateSigned1',
    integrationMetadata: null,
    placeholder: '',
  },
  {
    id: 'autofill-1',
    fontSize: 12,
    pageIndex: 0,
    x: 488,
    y: 267,
    required: true,
    linkId: '47c32da6-36b1-4151-b5ae-ed8033139737',
    autoFillType: 'name',
    type: 'text',
    width: 72,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'arial',
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    name: 'FullName1',
    integrationMetadata: null,
    masked: false,
    placeholder: 'Full name',
  },
  {
    id: 'autofill-2',
    fontSize: 12,
    pageIndex: 0,
    x: 488,
    y: 353,
    required: true,
    linkId: '7e19dc38-836f-43ca-9738-ed23b88234f4',
    autoFillType: 'email',
    type: 'text',
    width: 144,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'arial',
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    validationType: 'email_address',
    placeholder: 'Email address',
    integrationMetadata: null,
    name: 'Email1',
  },
  {
    id: 'autofill-3',
    fontSize: 12,
    pageIndex: 0,
    x: 488,
    y: 442,
    required: true,
    linkId: '409a843d-4185-45ac-b636-66a1d267e07c',
    autoFillType: 'company',
    type: 'text',
    width: 144,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'arial',
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    placeholder: 'Company',
    integrationMetadata: null,
    name: 'Company1',
  },

  checkbox1,
  {
    id: 'dropdown-1',
    fontSize: 12,
    pageIndex: 0,
    x: 183,
    y: 648,
    required: true,
    linkId: null,
    type: 'dropdown',
    width: 95,
    height: 14,
    fontFamily: 'arial',
    options: [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday',
    ],
    signer: '1',
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    name: 'Day of the week',
    integrationMetadata: null,
  },
  {
    id: 'checkbox-2',
    pageIndex: 0,
    x: 485,
    y: 722,
    required: false,
    linkId: null,
    type: 'checkbox',
    width: 18,
    height: 18,
    signer: '1',
    checked: false,
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    integrationMetadata: null,
    name: 'A',
    groupLabel: 'IDK',
    group: 'd74243784714d',
    requirement: 'require_2',
  },
  {
    id: 'checkbox-3',
    pageIndex: 0,
    x: 485,
    y: 754,
    required: false,
    linkId: null,
    type: 'checkbox',
    width: 18,
    height: 18,
    signer: '1',
    checked: false,
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    name: 'B',
    integrationMetadata: null,
    groupLabel: 'IDK',
    group: 'd74243784714d',
    requirement: 'require_2',
  },
  {
    id: 'checkbox-4',
    pageIndex: 0,
    x: 485,
    y: 787,
    required: false,
    linkId: null,
    type: 'checkbox',
    width: 18,
    height: 18,
    signer: '1',
    checked: false,
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    name: 'C',
    integrationMetadata: null,
    groupLabel: 'IDK',
    group: 'd74243784714d',
    requirement: 'require_2',
  },
  {
    id: 'checkbox-5',
    pageIndex: 0,
    x: 485,
    y: 819,
    required: false,
    linkId: null,
    type: 'checkbox',
    width: 18,
    height: 18,
    signer: '1',
    checked: false,
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    name: 'D',
    integrationMetadata: null,
    groupLabel: 'IDK',
    group: 'd74243784714d',
    requirement: 'require_2',
  },

  {
    id: 'checkbox E',
    pageIndex: 0,
    x: 515,
    y: 722,
    required: false,
    linkId: null,
    type: 'checkbox',
    width: 18,
    height: 18,
    signer: '1',
    checked: false,
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    integrationMetadata: null,
    name: 'E',
    groupLabel: 'IDK',
    group: 'd74243784714d',
    requirement: 'require_2',
  },
  {
    id: 'checkbox F',
    pageIndex: 0,
    x: 515,
    y: 754,
    required: false,
    linkId: null,
    type: 'checkbox',
    width: 18,
    height: 18,
    signer: '1',
    checked: false,
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    integrationMetadata: null,
    name: 'F',
    groupLabel: 'IDK',
    group: 'd74243784714d',
    requirement: 'require_2',
  },

  {
    id: 'radio-1',
    checked: false,
    pageIndex: 0,
    x: 188,
    y: 740,
    required: false,
    linkId: null,
    type: 'radiobutton',
    width: 16,
    height: 16,
    signer: '1',
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    name: 'Dogs',
    integrationMetadata: null,
    requirement: 'require_1',
    group: 'ab496e408a9d3',
    groupLabel: 'Favorite Pet',
  },
  {
    id: 'radio-2',
    checked: false,
    pageIndex: 0,
    x: 188,
    y: 764,
    required: false,
    linkId: null,
    type: 'radiobutton',
    width: 16,
    height: 16,
    signer: '1',
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    name: 'Cats',
    integrationMetadata: null,
    requirement: 'require_1',
    group: 'ab496e408a9d3',
    groupLabel: 'Favorite Pet',
  },
  {
    id: 'radio-3',
    checked: false,
    pageIndex: 0,
    x: 188,
    y: 789,
    required: false,
    linkId: null,
    type: 'radiobutton',
    width: 16,
    height: 16,
    signer: '1',
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    name: 'Birds',
    integrationMetadata: null,
    requirement: 'require_1',
    group: 'ab496e408a9d3',
    groupLabel: 'Favorite Pet',
  },
];
export const originalPages: SignatureRequest['pages'] = [
  {
    src: samplePage,
    width: 8.5 * DPI,
    height: 11 * DPI,
    documentId: '173b3c2dfb3e161b2368e8f911105cead9c21dc9',
    orientation: 1,
  },
];

export const singleZenPage: SignatureRequest['pages'] = [
  {
    src: zenPage,
    width: 8.5 * DPI,
    height: 11 * DPI,
    documentId: 'zen-page-document',
    orientation: 1,
  },
];

export const autofillAndConditionalLogic: Omit<
  SignatureRequest,
  'attachmentSlots'
> = {
  pages: singleZenPage,
  dpi: DPI,
  fields: [
    {
      signer: '1',
      pageIndex: 0,
      x: 42,
      y: 20,
      width: 75,
      height: 14,
      id: '42a1db3bc781ef2c5c39883eb6db190eba17cbf1___c2f25ebf-2f2d-41d2-b359-8c0bdd14b39d',
      documentId: '47a9498a39c658ca7864ae0094a606462b92cf5c',
      readOnly: false,
      required: true,
      name: 'Textbox1',
      type: 'text',
      placeholder: 'Textbox1',
      fontSize: 12,
      originalFontSize: 12,
      fontFamily: 'notoSans',
      value: '',
      masked: false,
    },
    {
      signer: '1',
      pageIndex: 0,
      x: 43,
      y: 64,
      width: 75,
      height: 14,
      id: '42a1db3bc781ef2c5c39883eb6db190eba17cbf1___a48fafb2-9ef2-48bf-bf66-9c5b581613bb',
      documentId: '47a9498a39c658ca7864ae0094a606462b92cf5c',
      readOnly: false,
      required: true,
      linkId: '858e74d8-6587-4188-bcf7-2999d022e2bd',
      name: 'FullName1',
      type: 'text',
      placeholder: 'Full name',
      fontSize: 12,
      originalFontSize: 12,
      fontFamily: 'notoSans',
      value: 'asdf',
      masked: false,
      autoFillType: 'name',
      lines: 'asdf',
      isAutoFill: true,
      autoFillValue: 'asdf',
    },
    {
      signer: '1',
      pageIndex: 0,
      x: 43,
      y: 106,
      width: 75,
      height: 14,
      id: '42a1db3bc781ef2c5c39883eb6db190eba17cbf1___f093e568-572e-483e-8034-65f459e64085',
      documentId: '47a9498a39c658ca7864ae0094a606462b92cf5c',
      readOnly: false,
      required: false,
      linkId: '858e74d8-6587-4188-bcf7-2999d022e2bd',
      name: 'FullName2',
      type: 'text',
      placeholder: 'Full name',
      fontSize: 12,
      originalFontSize: 12,
      fontFamily: 'notoSans',
      value: 'asdf',
      masked: false,
      autoFillType: 'name',
      lines: 'asdf',
      isAutoFill: true,
      autoFillValue: 'asdf',
    },
    {
      signer: '1',
      pageIndex: 0,
      x: 142,
      y: 122,
      width: 18,
      height: 18,
      id: '42a1db3bc781ef2c5c39883eb6db190eba17cbf1___7ba6df52-0b2b-4188-9cc4-c67bbcfd9788',
      documentId: '47a9498a39c658ca7864ae0094a606462b92cf5c',
      readOnly: false,
      required: false,
      name: 'Checkbox1',
      type: 'checkbox',
      checked: false,
    },
  ],
  rules: [
    {
      id: '8884f0df-f14f-4ff4-b183-d7888b155f89',
      triggerOperator: 'AND',
      triggers: [
        {
          id: '42a1db3bc781ef2c5c39883eb6db190eba17cbf1___7ba6df52-0b2b-4188-9cc4-c67bbcfd9788',
          operator: 'is',
          value: true,
        },
      ],
      actions: [
        {
          type: 'change-field-visibility',
          fieldId:
            '42a1db3bc781ef2c5c39883eb6db190eba17cbf1___f093e568-572e-483e-8034-65f459e64085',
          hidden: false,
        },
      ],
    },
  ],
};

export const veryTallPage: SignatureRequest = {
  pages: [
    {
      src: tallPage, // 1477x10825px

      // The client-side code is capable of using any arbitrary resolution. I
      // took the pixels of the image, but it left me with such a small grid I
      // had to multiply it by 100.  I just made the image in Miro, so I didn't
      // make it an exact size or aspect ratio.
      width: (1477 / DPI) * 100,
      height: (10825 / DPI) * 100,
      documentId: 'CVS 3c2dfb3e161b2368e8f911105cead9c21dc9',
      orientation: 1,
    },
  ],
  dpi: DPI,
  fields: [
    {
      ...signature1,
      id: '1x0.5 top left',
      x: 72,
      y: 36,
      height: 36,
      width: 72,
      documentId: 'CVS 3c2dfb3e161b2368e8f911105cead9c21dc9',
    },
    {
      ...signature1,
      id: '1x0.5 bottom right',
      x: 147700 / DPI - 72 - 72,
      y: 1082500 / DPI - 72,
      height: 36,
      width: 72,
      documentId: 'CVS 3c2dfb3e161b2368e8f911105cead9c21dc9',
    },
    {
      ...checkbox1,
      id: 'Center checkbox',
      documentId: 'CVS 3c2dfb3e161b2368e8f911105cead9c21dc9',
      x: 147700 / DPI / 2 - 36,
      y: 1082500 / DPI / 2 - 36,
      height: 72,
      width: 72,
    },
  ],
  rules: [],
  attachmentSlots: [],
  signerOptions: {
    signatureDateTimestamp: true,
  },
};

/**
 * Outside of Storybook, the backend would be responsible for filling in these
 * values
 */
const autofillFields = (f: Field): Field => {
  if (f.type === 'text' && f.autoFillType === 'name') {
    return {
      ...f,
      isAutoFill: true,
      autoFillValue: 'Lauren Ipsum',
      value: 'Lauren Ipsum',
    };
  }
  if (f.type === 'text' && f.autoFillType === 'email') {
    return {
      ...f,
      isAutoFill: true,
      autoFillValue: 'lauren@example.com',
      value: 'lauren@example.com',
    };
  }
  if (f.type === 'text' && f.autoFillType === 'company') {
    return {
      ...f,
      isAutoFill: true,
      autoFillValue: 'Dropbox',
      value: 'Dropbox',
    };
  }
  return f;
};

export const varietyOfFields: Array<Field> = [
  {
    pageIndex: 0,
    x: 28,
    y: 29,
    required: true,
    linkId: null,
    type: 'signature',
    width: 108,
    height: 27,
    signer: '1',
    readOnly: false,
    documentId: '32f53900fea3784c2ec2b70708e91be5a44c385f',
    integrationMetadata: null,
    name: 'Signature1',
    id: 'Signature1',
  },
  {
    pageIndex: 0,
    x: 28,
    y: 77,
    required: true,
    linkId: null,
    type: 'initials',
    width: 72,
    height: 27,
    signer: '1',
    documentId: '32f53900fea3784c2ec2b70708e91be5a44c385f',
    name: 'Initial1',
    id: 'Initial1',
    integrationMetadata: null,
  },
  {
    fontSize: 12,
    pageIndex: 0,
    x: 28,
    y: 127,
    required: true,
    linkId: null,
    type: 'date',
    width: 104,
    height: 18,
    dateFormat: 'default',
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '32f53900fea3784c2ec2b70708e91be5a44c385f',
    name: 'DateSigned1',
    id: 'DateSigned1',
    integrationMetadata: null,
    placeholder: '',
  },
  {
    fontSize: 12,
    pageIndex: 0,
    x: 28,
    y: 165,
    required: true,
    linkId: 'd46f703e-573c-4756-bdb7-bb0f305e898f',
    type: 'text',
    width: 72,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '32f53900fea3784c2ec2b70708e91be5a44c385f',
    name: 'FullName1',
    id: 'FullName1',
    integrationMetadata: null,
    masked: false,
    placeholder: 'Full name',
  },
  {
    fontSize: 12,
    pageIndex: 0,
    x: 28,
    y: 192,
    required: true,
    linkId: '6f90b1d4-c819-40a9-a070-2b2a304d334a',
    type: 'text',
    width: 144,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '32f53900fea3784c2ec2b70708e91be5a44c385f',
    validationType: 'email_address',
    placeholder: 'Email address',
    integrationMetadata: null,
    name: 'Email1',
    id: 'Email1',
  },
  {
    fontSize: 12,
    pageIndex: 0,
    x: 28,
    y: 220,
    required: true,
    linkId: 'ce9e86fb-33ad-4428-a74d-c03943a2043d',
    type: 'text',
    width: 144,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '32f53900fea3784c2ec2b70708e91be5a44c385f',
    placeholder: 'Company',
    integrationMetadata: null,
    name: 'Company1',
    id: 'Company1',
  },
  {
    fontSize: 12,
    pageIndex: 0,
    x: 28,
    y: 245,
    required: true,
    linkId: 'bf99ebee-7135-489b-933d-dde92f32c4c4',
    type: 'text',
    width: 144,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '32f53900fea3784c2ec2b70708e91be5a44c385f',
    placeholder: 'Title',
    integrationMetadata: null,
    name: 'Title1',
    id: 'Title1',
  },

  {
    fontSize: 12,
    pageIndex: 0,
    x: 200,
    y: 165,
    required: true,
    linkId: null,
    type: 'text',
    width: 70,
    height: 72,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '32f53900fea3784c2ec2b70708e91be5a44c385f',
    name: 'Textbox1',
    integrationMetadata: null,
    masked: false,
    placeholder: 'multiline',
    id: 'multiline',
  },

  {
    pageIndex: 0,
    x: 28,
    y: 313,
    required: false,
    linkId: null,
    type: 'checkbox',
    width: 18,
    height: 18,
    signer: '1',
    checked: false,
    documentId: '32f53900fea3784c2ec2b70708e91be5a44c385f',
    name: 'Checkbox1',
    id: 'Checkbox1',
    integrationMetadata: null,
  },
  {
    fontSize: 12,
    pageIndex: 0,
    x: 58,
    y: 317,
    required: true,
    linkId: null,
    type: 'text',
    width: 144,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '32f53900fea3784c2ec2b70708e91be5a44c385f',
    placeholder: 'Textbox2',
    integrationMetadata: null,
    name: 'Textbox2',
    id: 'Textbox2',
  },
  {
    fontSize: 12,
    pageIndex: 0,
    x: 27,
    y: 351,
    required: true,
    linkId: null,
    type: 'dropdown',
    width: 60,
    height: 15,
    fontFamily: 'arial',
    options: ['cat', 'dog', 'fish', 'other'],
    signer: '1',
    documentId: '32f53900fea3784c2ec2b70708e91be5a44c385f',
    name: 'Dropdown1',
    id: 'Dropdown1',
    integrationMetadata: null,
  },
  {
    fontSize: 12,
    pageIndex: 0,
    x: 98,
    y: 353,
    required: true,
    linkId: null,
    type: 'text',
    width: 144,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '32f53900fea3784c2ec2b70708e91be5a44c385f',
    placeholder: 'Textbox3',
    integrationMetadata: null,
    name: 'Textbox3',
    id: 'Textbox3',
  },
];

export const checkboxes0to1: Array<Field> = [
  {
    pageIndex: 0,
    x: 43,
    y: 40,
    required: false,
    linkId: null,
    type: 'checkbox',
    width: 18,
    height: 18,
    signer: '1',
    checked: false,
    documentId: '53da8e5a0824bdab58aaf0a745aff064d39c585d',
    name: 'Checkbox1',
    id: 'Checkbox1',
    integrationMetadata: null,
    group: '9fc9a119d9d6b',
    requirement: 'require_0-1',
    groupLabel: 'CheckboxGroup1',
  },
  {
    pageIndex: 0,
    x: 43,
    y: 79,
    required: false,
    linkId: null,
    type: 'checkbox',
    width: 18,
    height: 18,
    signer: '1',
    checked: false,
    documentId: '53da8e5a0824bdab58aaf0a745aff064d39c585d',
    integrationMetadata: null,
    name: 'Checkbox2',
    id: 'Checkbox2',
    group: '9fc9a119d9d6b',
    requirement: 'require_0-1',
    groupLabel: 'CheckboxGroup1',
  },
  {
    pageIndex: 0,
    x: 43,
    y: 118,
    required: false,
    linkId: null,
    type: 'checkbox',
    width: 18,
    height: 18,
    signer: '1',
    checked: false,
    documentId: '53da8e5a0824bdab58aaf0a745aff064d39c585d',
    integrationMetadata: null,
    name: 'Checkbox3',
    id: 'Checkbox3',
    group: '9fc9a119d9d6b',
    requirement: 'require_0-1',
    groupLabel: 'CheckboxGroup1',
  },
];

export const everyTextValidation: Array<Field> = [
  {
    id: 'validation-street-address',
    fontSize: 12,
    pageIndex: 0,
    x: 55,
    y: 49,
    required: true,
    linkId: null,
    type: 'text',
    width: 72,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '2e3f7962370422bdd061bf4f5123537194b8e2e6',
    name: 'Street Address',
    integrationMetadata: null,
    masked: false,
    placeholder: 'Street Address',
  },
  {
    id: 'validation-numbers-only',
    fontSize: 12,
    pageIndex: 0,
    x: 55,
    y: 91,
    required: true,
    linkId: null,
    type: 'text',
    width: 72,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '2e3f7962370422bdd061bf4f5123537194b8e2e6',
    placeholder: 'Numbers only',
    integrationMetadata: null,
    name: 'Numbers Only',
    validationType: 'numbers_only',
  },
  {
    id: 'validation-letters-only',
    fontSize: 12,
    pageIndex: 0,
    x: 55,
    y: 130,
    required: true,
    linkId: null,
    type: 'text',
    width: 72,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '2e3f7962370422bdd061bf4f5123537194b8e2e6',
    placeholder: 'Letters only',
    integrationMetadata: null,
    name: 'Letters Only',
    validationType: 'letters_only',
  },
  {
    id: 'validation-phone-number',
    fontSize: 12,
    pageIndex: 0,
    x: 55,
    y: 165,
    required: true,
    linkId: null,
    type: 'text',
    width: 71,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '2e3f7962370422bdd061bf4f5123537194b8e2e6',
    placeholder: '(USA) Phone number',
    integrationMetadata: null,
    name: 'Phone Number',
    validationType: 'phone_number',
  },
  {
    id: 'validation-bank-routing-number',
    fontSize: 12,
    pageIndex: 0,
    x: 55,
    y: 199,
    required: true,
    linkId: null,
    type: 'text',
    width: 71,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '2e3f7962370422bdd061bf4f5123537194b8e2e6',
    placeholder: '(USA) Bank routing number',
    integrationMetadata: null,
    name: 'Bank Routing Number',
    validationType: 'bank_routing_number',
  },
  {
    id: 'validation-email-address',
    fontSize: 12,
    pageIndex: 0,
    x: 55,
    y: 236,
    required: true,
    linkId: null,
    type: 'text',
    width: 71,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '2e3f7962370422bdd061bf4f5123537194b8e2e6',
    placeholder: 'Email address',
    integrationMetadata: null,
    name: 'Email Address',
    validationType: 'email_address',
  },
  {
    id: 'validation-zip-code',
    fontSize: 12,
    pageIndex: 0,
    x: 55,
    y: 279,
    required: true,
    linkId: null,
    type: 'text',
    width: 71,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '2e3f7962370422bdd061bf4f5123537194b8e2e6',
    placeholder: '(USA) Zip code',
    integrationMetadata: null,
    name: 'Textbox4',
    validationType: 'zip_code',
  },
  {
    id: 'validation-social-security-number',
    fontSize: 12,
    pageIndex: 0,
    x: 55,
    y: 320,
    required: true,
    linkId: null,
    type: 'text',
    width: 71,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '2e3f7962370422bdd061bf4f5123537194b8e2e6',
    placeholder: '(USA) Social security number',
    integrationMetadata: null,
    name: 'SSN',
    validationType: 'social_security_number',
  },
  {
    id: 'validation-employer-identification-number',
    fontSize: 12,
    pageIndex: 0,
    x: 55,
    y: 360,
    required: true,
    linkId: null,
    type: 'text',
    width: 71,
    height: 12,
    lineHeight: 12,
    signer: '1',
    fontFamily: 'notoSans',
    documentId: '2e3f7962370422bdd061bf4f5123537194b8e2e6',
    placeholder: '(USA) Employer identification number',
    integrationMetadata: null,
    name: 'Employer Identification Number',
    validationType: 'employer_identification_number',
  },
];

export const exampleSignatureRequest: SignatureRequest = {
  dpi: 72,
  fields: originalFields.map(autofillFields),
  pages: originalPages,
  rules: [],
  attachmentSlots: [],
  signerOptions: {
    signatureDateTimestamp: true,
  },
};
